var audio_rtlignore_default = {
  "fontElementMap": "KdFuO",
  "customPlayer": "GWuME",
  "customPlayer_basic": "M1Txd",
  "customPlayer_mobile": "GtPmF",
  "audio_coverImg": "_6S08p",
  "audio_small_cover_image": "_08G5W",
  "audio_icon_button": "u2ybY",
  "audio_contextMenu_wrapper": "SgKdB",
  "customPlayer_with_image": "gwCNq",
  "track_wrapper": "Y3N27",
  "trackContainer": "M4FC-",
  "audio_download_icon": "ewMmx",
  "audio_duration": "tFKaI",
  "customPlayer_small_fit": "pdfHU",
  "track_sliders_wrapper": "UC3-q",
  "audio_volume_wrapper": "zPd12",
  "volume_slider_wrapper": "zvJAC",
  "audioDetails": "bp4sT",
  "title": "_8jafk",
  "author_name": "Nla2s",
  "dropdown_menu_wrapper": "_5bKyO",
  "dropdown_selected_button": "S2vgX",
  "dropdown_content": "pzI9D",
  "dropdown_content_withIcon": "evMkh",
  "audio_loader_icon": "_9J7tZ",
  "spin": "bzMkU"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
